import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, FlashbarProps, Form, FormField, Input, SegmentedControl, SpaceBetween, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format, parse } from 'date-fns';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import SelectAirline from '../../../../components/selects/SelectAirline';
import SelectAirport from '../../../../components/selects/SelectAirport';
import SelectBelt from '../../../../components/selects/SelectBelt';
import SelectGate from '../../../../components/selects/SelectGate';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const FlightsAddPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [direction, setDirection] = useState("")
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [flight, setFlight] = useState<ItemFlight>({} as ItemFlight);
    const { navigate } = useRouter();
    const { idAirport, menu } = useGlobalState();


    useEffect(() => {

    }, []);


    const handleUpdateFlight = async () => { // Make the function async    
        try {
            setLoading(true)

            const payload = {
                idFlight: 0,
                idStatus: flight.idStatus,
                idGate: 0,
                idBelt: 0,
                departureTime: "",
                arrivalTime: "",
                boardingTime: "",
                departureTimeReal: "",
                arrivalTimeReal: "",
                boardingTimeReal: "",
                isActive: 1,
                isClosed: 0,
                isCancel: 0,
                idAirportOrigin: flight.idAirportOrigin,
                idAirportDestination: flight.idAirportDestination,
                idAirline: flight.idAirline,
                flightNumber: flight.flightNumber,
                date: format(new Date(), "dd-MM-yyyy"),
            };
            if (direction === "OUT") {
                payload['departureTimeReal'] = flight.departureTimeReal;
                payload['departureTime'] = flight.departureTime;
                payload['boardingTimeReal'] = flight.boardingTimeReal;
                payload['boardingTime'] = flight.boardingTime;

                payload['idGate'] = flight.idGate;

            } else if (direction === "IN") {
                payload['arrivalTimeReal'] = flight.arrivalTimeReal;
                payload['arrivalTime'] = flight.arrivalTime;
                payload['idBelt'] = flight.idBelt;
            }
            console.log(payload);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/update',
                },
                body: JSON.stringify(payload),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, "success", setData);
                setFlight({} as ItemFlight);
                setDirection("");
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    };
    const isValidFlight = (flight: ItemFlight) => {
        if (!flight) return false;
        if (!flight.idAirportOrigin || flight.idAirportOrigin == 0) return false;
        if (!flight.idAirportDestination || flight.idAirportDestination == 0) return false;
        if (!flight.idAirline || flight.idAirline == 0) return false;
        if (!flight.flightNumber || flight.flightNumber == "") return false;
        if (direction === "OUT") {
            if (!flight.departureTime || flight.departureTime == "") return false;
            if (!flight.boardingTime || flight.boardingTime == "") return false;
            if (!flight.idGate || flight.idGate == 0) return false;
        } else if (direction === "IN") {
            if (!flight.arrivalTime || flight.arrivalTime == "") return false;
            if (!flight.idBelt || flight.idBelt == 0) return false;
        }
        return true;
    }

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description={"Ingreso manual de vuelo"}>Ingreso</Header>
                    <Form actions={<Button variant="primary" disabled={!isValidFlight(flight)} onClick={() => {
                        console.log(flight);
                        handleUpdateFlight();
                    }
                    }>Ingresar vuelo</Button>}>

                        <SegmentedControl selectedId={direction} onChange={e => {
                            setDirection(e.detail.selectedId)
                            const rawDate = format(new Date(), "dd-MM-yyyy HH:00");
                            let baseObject = {
                                idGate: 0,
                                idBelt: 0,
                                idStatus: 0,
                                idAirportOrigin: 0,
                                idAirportDestination: 0,
                                arrivalTime: "",
                                arrivalTimeReal: "",
                                departureTime: "",
                                departureTimeReal: "",
                                boardingTime: "",
                                boardingTimeReal: ""
                            };


                            if (flight && !flight.arrivalTime) {
                                baseObject.arrivalTime = rawDate;
                                baseObject.arrivalTimeReal = rawDate;
                            } else {
                                baseObject.arrivalTime = flight.arrivalTime;
                                baseObject.arrivalTimeReal = flight.arrivalTimeReal;
                            }


                            if (flight && !flight.departureTime) {
                                baseObject.departureTime = rawDate;
                                baseObject.departureTimeReal = rawDate;
                            } else {
                                baseObject.departureTime = flight.departureTime;
                                baseObject.departureTimeReal = flight.departureTimeReal;
                            }

                            if (flight && !flight.boardingTime) {
                                baseObject.boardingTime = rawDate;
                                baseObject.boardingTimeReal = rawDate;
                            } else {
                                baseObject.boardingTime = flight.boardingTime;
                                baseObject.boardingTimeReal = flight.boardingTimeReal;
                            }
                            setFlight({ ...flight, ...baseObject });
                        }}
                            options={[
                                { id: "OUT", text: "Salida" },
                                { id: "IN", text: "Llegada" },
                            ]}

                        />
                        {direction && direction !== "" && (
                            <SpaceBetween size="m" direction='vertical'>
                                <SpaceBetween size="m" direction='horizontal'>
                                    <div style={{ minWidth: 200 }}>
                                        <FormField label="Origen">
                                            {direction === "OUT" ?
                                                <SelectAirport single value={idAirport || 0} readonly />

                                                : <SelectAirport disabledAirports={[idAirport]} single value={flight.idAirportDestination || 0}
                                                    onSelect={(airport) => {
                                                        setFlight({ ...flight, idAirportOrigin: airport || 0, idAirportOwner: idAirport, idAirportDestination: idAirport });
                                                    }} />}
                                        </FormField>
                                    </div>
                                    <div style={{ minWidth: 200 }}>
                                        <FormField label="Destino">
                                            {direction === "IN" ? <SelectAirport single value={idAirport || 0} readonly /> : <SelectAirport disabledAirports={[idAirport]} single value={flight.idAirportDestination || 0}
                                                onSelect={(airport) => {
                                                    setFlight({ ...flight, idAirportDestination: airport || 0, idAirportOwner: idAirport, idAirportOrigin: idAirport, });
                                                }}
                                            />}

                                        </FormField>
                                    </div>
                                </SpaceBetween>
                                {flight && flight.idAirportOrigin > 0 && flight.idAirportDestination > 0 && (
                                    <>
                                        <SpaceBetween size="m" direction='horizontal'>
                                            <FormField label="Aerolinea">
                                                <SelectAirline single value={flight.idAirline || 0}
                                                    onSelect={(airline) => {
                                                        setFlight({ ...flight, idAirline: airline || 0 });
                                                    }} />
                                            </FormField>
                                            <FormField label="Número de Vuelo">
                                                <Input
                                                    value={flight.flightNumber || ""} onChange={e => {
                                                        setFlight({ ...flight, flightNumber: e.detail.value });
                                                    }} />
                                            </FormField>
                                        </SpaceBetween>
                                        {direction === "OUT" ? (
                                            <SpaceBetween size="m" direction='vertical'>
                                                <SpaceBetween size="m" direction='horizontal'>
                                                    <FormField label="Fecha salida">
                                                        <DPModal date={format(parse(flight.departureTime, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") || ""} onConfirm={(date) => {
                                                            const currentTime = flight.departureTime.split(' ')[1] || "00:00";
                                                            setFlight({ ...flight, departureTime: `${date} ${currentTime}`, departureTimeReal: `${date} ${currentTime}` });
                                                        }} />
                                                    </FormField>
                                                    <FormField label="Hora salida">
                                                        <TimeInput format="hh:mm" value={format(parse(flight.departureTime, "dd-MM-yyyy HH:mm", new Date()), "HH:mm") || ""}
                                                            onChange={(e) => {
                                                                const currentDate = flight.departureTime.split(' ')[0] || format(new Date(), "dd-MM-yyyy");
                                                                if (e && e.detail && e.detail.value.length === 5) {
                                                                    setFlight({
                                                                        ...flight, departureTime: `${currentDate} ${e.detail.value}`,
                                                                        departureTimeReal: `${currentDate} ${e.detail.value}`
                                                                    });
                                                                }

                                                            }} />
                                                    </FormField>
                                                </SpaceBetween>

                                                <SpaceBetween size="m" direction='horizontal'>
                                                    <FormField label="Fecha embarque">
                                                        <DPModal date={format(parse(flight.boardingTime || "", "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") || ""} onConfirm={(date) => {
                                                            const currentTime = flight.boardingTime.split(' ')[1] || "00:00";
                                                            setFlight({ ...flight, boardingTime: `${date} ${currentTime}`, boardingTimeReal: `${date} ${currentTime}` });
                                                        }} />
                                                    </FormField>
                                                    <FormField label="Hora embarque">
                                                        <TimeInput format="hh:mm" value={format(parse(flight.boardingTime || "", "dd-MM-yyyy HH:mm", new Date()), "HH:mm") || ""}
                                                            onChange={(e) => {
                                                                if (e && e.detail && e.detail.value.length === 5) {
                                                                    const currentDate = flight.boardingTime.split(' ')[0] || format(new Date(), "dd-MM-yyyy");
                                                                    setFlight({ ...flight, boardingTime: `${currentDate} ${e.detail.value}`, boardingTimeReal: `${currentDate} ${e.detail.value}` });
                                                                }
                                                            }} />
                                                    </FormField>
                                                </SpaceBetween>

                                                <SpaceBetween size="m" direction='horizontal'>
                                                    <FormField label="Puerta">
                                                        <SelectGate single value={flight.idGate || 0}
                                                            onSelect={(gate) => {
                                                                setFlight({ ...flight, idGate: gate || 0 });
                                                            }} />
                                                    </FormField>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        ) : (

                                            <SpaceBetween size="m" direction='vertical'>
                                                <SpaceBetween size="m" direction='horizontal'>
                                                    <FormField label="Fecha llegada">
                                                        <DPModal date={format(parse(flight.arrivalTime || "", "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") || ""} onConfirm={(date) => {
                                                            const currentTime = flight.arrivalTime.split(' ')[1] || "00:00";
                                                            setFlight({ ...flight, arrivalTime: `${date} ${currentTime}`, arrivalTimeReal: `${date} ${currentTime}` });
                                                        }} />
                                                    </FormField>
                                                    <FormField label="Hora llegada">
                                                        <TimeInput format="hh:mm" value={format(parse(flight.arrivalTime || "", "dd-MM-yyyy HH:mm", new Date()), "HH:mm") || ""}
                                                            onChange={(e) => {
                                                                if (e && e.detail && e.detail.value.length === 5) {
                                                                    const currentDate = flight.arrivalTime.split(' ')[0] || format(new Date(), "dd-MM-yyyy");
                                                                    setFlight({ ...flight, arrivalTime: `${currentDate} ${e.detail.value}`, arrivalTimeReal: `${currentDate} ${e.detail.value}` });
                                                                }
                                                            }} />
                                                    </FormField>
                                                </SpaceBetween>
                                                <SpaceBetween size="m" direction='horizontal'>
                                                    <FormField label="Cinta">
                                                        <SelectBelt single value={flight.idBelt || 0}
                                                            onSelect={(belt) => {
                                                                setFlight({ ...flight, idBelt: belt || 0 });
                                                            }} />
                                                    </FormField>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )}
                                    </>
                                )}

                            </SpaceBetween>
                        )}
                    </Form>
                </SpaceBetween>

            }
        />
    )
};
